<template>
	<div>
		<div :class="headingClass">
			<slot name="heading">{{ heading }}</slot>
		</div>
		<div :class="titleClass">
			<slot name="title">{{ title }}</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AoWidget',
	props: {
		heading: {
			type: [String, Number],
			default: '',
		},
		title: {
			type: [String, Number],
			default: '',
		},
		headingClass: {
			type: String,
			default: 'ao-c3 mb-1 ao-text-secondary-color-700'
		},
		titleClass: {
			type: String,
			default: 'ao-h2'
		},
	},
}
</script>
